import { event, GtagEvent } from "./event";
export interface LevelStart extends GtagEvent {
    level_name?:string;
}
export const level_start = ($_?:LevelStart) => event('level_start',$_);